import { Injectable } from '@angular/core';
import { StoreKey } from '@app/shared';
import { environment } from 'environments/environment';
import { io, Socket } from 'socket.io-client';

@Injectable({ providedIn: 'root' })
export class SocketService {
  socket: Socket | undefined;

  init(userId: string) {
    if (environment?.connectSocket) {
      const token = sessionStorage.getItem(StoreKey.TOKEN) as string;

      const ioUrl = `${environment.apiSocket.protocol}://${environment.apiSocket.domain}:${environment.apiSocket.port}`;
      this.socket = io(ioUrl, { auth: { userId, token } });

      this.socket.on('connect', () => {
        console.log('socket Connected?', this.socket?.connected);
      });
    } else {
      if (this.socket) this.disconnect();
      console.log('LOCALHOST: SOCKET NOT CONNECTED');
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
